import { OAuthSession } from './oauth-session.js';

export const fetchData = async (...params: Parameters<typeof fetch>) => {
  const url = params[0];
  const options = params.length === 2 ? params[1] : {};

  if (!(await OAuthSession.isActive())) {
    return {
      status: 401,
      json: async () => '{}'
    };
  }

  const authorizationHeader = {
    Authorization: OAuthSession.getAccessToken() ?? ''
  };

  const result = await fetch(url, {
    ...options,
    headers: {
      ...options?.headers,
      ...authorizationHeader
    }
  });

  return result;
};
